/* eslint-disable sort-keys-fix/sort-keys-fix */
// NOTE: name should be lowercase as lowercase serializer is used.
export const MEDIA_ADMIN_ROUTE = {
  name: 'mediaadministrator',
  route(): string[] {
    return ['/' + this.name];
  },
  COLLECTION: {
    name: 'collection/:collectionid',
    route(collectionId: string): string[] {
      return [...MEDIA_ADMIN_ROUTE.route(), 'collection', collectionId];
    },
    EDIT: {
      name: 'edit',
      route(collectionId: string): string[] {
        return [...MEDIA_ADMIN_ROUTE.COLLECTION.route(collectionId), this.name];
      },
    },
    ASSET: {
      name: 'asset/:sectionid/:assetid',
      route(collectionId: string, sectionId: string, assetId: string): string[] {
        return [...MEDIA_ADMIN_ROUTE.COLLECTION.route(collectionId), 'asset', sectionId, assetId];
      },
      EDIT: {
        name: 'edit',
        route(collectionId: string, sectionId: string, assetId: string): string[] {
          return [...MEDIA_ADMIN_ROUTE.COLLECTION.ASSET.route(collectionId, sectionId, assetId), this.name];
        },
      },
    },
    SECTION: {
      name: 'section/:sectionid',
      route(collectionId: string, sectionId: string) {
        return [...MEDIA_ADMIN_ROUTE.COLLECTION.route(collectionId), 'section', sectionId];
      },
      EDIT: {
        name: 'edit',
        route(collectionId: string, sectionId: string): string[] {
          return [...MEDIA_ADMIN_ROUTE.COLLECTION.SECTION.route(collectionId, sectionId), this.name];
        },
      },
    },
  },
  EXPERT: {
    name: 'expert',
    route(): string[] {
      return [...MEDIA_ADMIN_ROUTE.route(), this.name];
    },
    EDIT: {
      name: ':expertid/edit',
      route(expertId: string): string[] {
        return [...MEDIA_ADMIN_ROUTE.EXPERT.route(), expertId, 'edit'];
      }
    },
  },
  HOME: {
    name: 'home',
    route(): string[] {
      return [...MEDIA_ADMIN_ROUTE.route(), this.name];
    }
  },
  TAGS: {
    name: 'tags',
    route(): string[] {
      return [...MEDIA_ADMIN_ROUTE.route(), this.name];
    }
  },
  SETTINGS: {
    name: 'settings',
    route(): string[] {
      return [...MEDIA_ADMIN_ROUTE.route(), this.name];
    }
  }
};